import React from "react";
import { useTheme } from "@mui/material/styles";
import { Icon } from "../../icons";
import { CustomSelectButton, SelectButtonContainer } from "./SelectButton.styles";
import { GradientStyles } from "./SelectButton.variants";

type GradientStylesReturnType = ReturnType<typeof GradientStyles>;
type GradientStylesType = keyof GradientStylesReturnType;

export interface CustomVariantSelectButtonProps {
    selectedSessionId?: number | undefined;
    sessionId?: number | undefined;
    children?: string | React.ReactNode | null;
    gradientStyle?: GradientStylesType;
}
// TODO: reimplement toggleSelect to this subcomponent once app widget is implemented
export const SelectButton = ({
    selectedSessionId,
    sessionId,
    gradientStyle = "gradient4",
    children = "Select",
}: CustomVariantSelectButtonProps) => {
    const theme = useTheme();

    const isSessionSelected = selectedSessionId && sessionId && selectedSessionId === sessionId;

    const gradientStylesFn = GradientStyles(theme);
    const conditionalGradient = isSessionSelected || gradientStyle === "priority" ? gradientStylesFn[gradientStyle] : {};

    return (
        <SelectButtonContainer>
            <CustomSelectButton
              sx={{
                ...conditionalGradient
              }}
              className={isSessionSelected ? "selected" : ""}>
                {isSessionSelected ? <Icon icon="Check" /> : children}
            </CustomSelectButton>
        </SelectButtonContainer>
    );
};

export interface SelectButtonProps extends React.ComponentProps<typeof SelectButton> {
    as?: React.ElementType;
  }

SelectButton.displayName = "SelectButton";